import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/700.css";
import "../app/globals.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import App from "./App";
import ErrorBoundary from "./_errors/ErrorBoundary";
import ThemeProvider from "./theme/ThemeProvider";
import { initSentry } from "./lib/sentry";
import { initPostHog } from "./lib/posthog";

// No-op until VITE_SENTRY_DSN is set in Vercel project env vars
// (Hector kickoff to-do); ErrorBoundary always falls through to ErrorPage.
initSentry();
// No-op until VITE_POSTHOG_KEY is set (autocapture/recording OFF, no PII —
// see src/lib/posthog.ts).
initPostHog();

const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <BrowserRouter>
          <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey ?? ""}>
            <App />
          </GoogleReCaptchaProvider>
        </BrowserRouter>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
